import userData from "toolkit/data/userData";
import { Project } from "./Project";

export const ProjectContainer = () => {
  const { projects } = userData;
  return (
    <div className="container project-container p-h-4" id="project">
      <h2 className="title sub-heading full-wd m-h-4 m-v-2">Projects that I've worked on</h2>
      <div className="grid-3-col full-wd m-auto">
        {projects?.map((project) => (
          <Project key={project._id} project={project} />
        ))}
      </div>
    </div>
  );
};
